<script>
  export let data;
  export let slideWidth;
  export let slideIsActive;
  export let hidden;
  export let anyActive;
  export let eventIndex;
  export let active;
  export let isReversedDueToLength;
  export let maxIndex;
  export let shouldRenderTitles;

  import Icon from "./Icon.svelte";

  import { windowWidth, isMobile, showAllTitles } from "../stores/global.js";

  import Title from "./Title.svelte";
  import Tooltip from "./Tooltip.svelte";

  $: paraHeight = null;
  $: iconHeight = null;

  let hovered = false;

  const setActive = function () {
    active = data.title;
    anyActive = true;
  };

  const noneActive = function () {
    active = null;
    anyActive = false;
  };

  const setHovered = function () {
    hovered = true;
  };

  const unhover = function () {
    hovered = false;
  };

  $: titleIsActive =
    slideIsActive &&
    (hovered ||
      active == data.title ||
      ($showAllTitles == true && slideIsActive));
</script>

<div
  class="event {anyActive
    ? active == data.title
      ? 'active'
      : 'inactive'
    : ''} {hidden ? 'hidden' : ''}
    {slideIsActive ? 'slide-active' : 'slide-inactive'}
    {eventIndex == 0 ? 'first-index' : ''}
    {eventIndex == maxIndex ? 'last-index' : ''}"
  on:mouseover={setHovered}
  on:focus={setHovered}
  on:mouseleave={unhover}
  on:blur={unhover}
  on:click={(e) => {
    // Only run on active slide
    if (!slideIsActive) {
      return;
    }
    // Do not trigger close on clicking of links
    if (e.target.nodeName == "A") {
      return;
    }
    active == data.title ? noneActive() : setActive();
  }}
>
  <div class="top-level-content {data.size}">
    <Icon {data} bind:iconHeight>
      {#if shouldRenderTitles}
        <Title
          size={data.size}
          title={data.title}
          {slideWidth}
          {eventIndex}
          {maxIndex}
          {isReversedDueToLength}
          active={titleIsActive}
          activeViaHover={hovered}
          bind:paraHeight
        />
      {/if}
    </Icon>
  </div>
  {#if active == data.title}
    {#if slideIsActive}
      <Tooltip
        type={data.type}
        width={$isMobile
          ? $windowWidth * 0.95 + "px"
          : slideWidth * 2 * 1.5 > 650
          ? 650
          : slideWidth * 2 * 1.5 + "px"}
        text={data.description}
        isMobile={$isMobile}
      />
    {/if}
  {/if}
</div>

<style>
  .event {
    display: flex;
    flex-direction: column;
    place-items: center;
    z-index: 20;
    position: relative;
    transition: opacity 300ms ease;
    cursor: pointer;
  }

  .top-level-content {
    margin: 7px 0;
  }

  .hidden,
  :global(.hidden > *) {
    /* visibility: hidden; */
    opacity: 0;
    transition: opacity 300ms ease;
    pointer-events: none !important;
    cursor: default;
  }

  .slide-inactive {
    cursor: default;
  }

  :global(.hidden .icon) {
    opacity: 0;
    transition: opacity 300ms ease;
  }

  /* If user opens tooltip for one event, deemphasize its neighbors */
  :global(.swiper-slide-active .inactive .title) {
    color: #cecece80;
  }

  :global(.swiper-slide-active .inactive .icon-container) {
    opacity: 0.5;
  }

  /* Deemphasize all SVGs not on current slide */
  :global(.swiper-slide:not(.swiper-slide-active) .icon) {
    opacity: 0.25;
    /* filter: brightness(0.65); */
  }

  /* DISABLE CLICK EVENTS ON EVENTS THAT ARE NOT IN ACTIVE SLIDE */
  :global(.swiper-slide:not(.swiper-slide-active)
      .slide
      .events
      .event-and-description-container) {
    pointer-events: none;
  }
</style>
